// src/recaptcha.js
export const RECAPTCHA_SITE_KEY = "6LcTQRAsAAAAAOkOeutRB22bWVT6lmBcfOttzvit";

export function loadRecaptcha() {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      reject(new Error("reCAPTCHA can only be loaded in the browser"));
      return;
    }

    // Already loaded
    if (window.grecaptcha) {
      resolve(window.grecaptcha);
      return;
    }

    // Script tag already exists, wait for it
    const existingScript = document.getElementById("recaptcha-v3-script");
    if (existingScript) {
      existingScript.addEventListener("load", () => {
        if (window.grecaptcha) {
          resolve(window.grecaptcha);
        } else {
          reject(new Error("reCAPTCHA script loaded but grecaptcha is missing"));
        }
      });
      existingScript.addEventListener("error", () =>
        reject(new Error("Failed to load reCAPTCHA script"))
      );
      return;
    }

    // Create script tag
    const script = document.createElement("script");
    script.id = "recaptcha-v3-script";
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      if (window.grecaptcha) {
        resolve(window.grecaptcha);
      } else {
        reject(new Error("reCAPTCHA script loaded but grecaptcha is missing"));
      }
    };

    script.onerror = () => reject(new Error("Failed to load reCAPTCHA script"));

    document.head.appendChild(script);
  });
}
